import http from "@/helper/http";
import {useMutation} from "@tanstack/react-query";
import {BaseVO} from "@/model/global";

export enum RegionEnum {
    RegionTree = "/region/getRegionTree",
}

/**
 * 行政规划树VO
 */
export interface RegionTreeVO {
    children: RegionTreeVO[];
    id: string;
    key: string;
    level: number;
    parentId: string;
    title: string;
    value: string;
}

export const useQueryRegionTree = () => useMutation({mutationFn: () => http.get<BaseVO<RegionTreeVO[]>>({url: RegionEnum.RegionTree})})

